import * as React from "react";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
const SvgText = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	viewBox: "0 0 20 20",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "inherit",
		fillRule: "nonzero",
		d: "M2.083 3.333v2.5H6.25v10h2.5v-10h4.167v-2.5H2.083zM17.917 7.5h-7.5V10h2.5v5.833h2.5V10h2.5V7.5z"
	})
});
export default SvgText;
